import store from "@/store";
import { SystemMessage } from "@/modules/staff/objects/conversation/SystemMessage";
import { ProjectService } from "@/framework/services/general/projectService";
import { AuthService } from "@/framework/api/AuthService";
import { QueryTenant } from "@/modules/admin/objects/hotelAdmin";
import { TenantService } from "@/framework/api/Admin/TenantService";
import { ErrorService } from "@/framework/errors/ErrorService";

const authService = new AuthService();

export const createGuestUrlForPwa = async (projectService: ProjectService, query: string) => {
  const tenantService = new TenantService();
  const errorService = new ErrorService(); // Get the tenant code from the store
  let tenantCode = store.getters.tenantCode;
  if (!tenantCode || (tenantCode && tenantCode.length == 0)) {
    const res = await tenantService.fetchTenantInfo();
    if (res.isErr()) {
      await errorService.handleError(res.error);
      return "";
    }

    const tenant: QueryTenant = res.value;
    tenantCode = tenant.code;
    store.dispatch("setTenantCode", tenantCode);
  }
  // Check the region
  const isBahrain = origin.length > 0 && origin.includes(".bh.");
  let domain = projectService.getDomain("fe-guest", isBahrain ? "bh" : "jp");
  if (!domain) {
    throw Error("openCouponWindow - No domain for fe-guest found.");
  }
  // Replace `SUBDOMAIN` with tenantCode
  domain = domain.replace("SUBDOMAIN", tenantCode);
  return `${domain}/home?${query}`;
};

export const openCouponWindow = async (systemMessage: SystemMessage) => {
  const couponId = systemMessage.metaData.coupon_id;
  const result = await authService.generateSsoLink();
  if (result.isOk()) {
    const token = result.value.token;
    const projectService = new ProjectService();
    const pageParam = "customer/coupon/" + couponId;
    const query = `page=${encodeURI(pageParam)}&token=${token}`;
    let url = "";
    try {
      url = await createGuestUrlForPwa(projectService, query);
      console.log("openCouponWindow - Pwa url: ", url);
    } catch (error) {
      console.error(error);
      return;
    }
    // added setTimeout for iPhone safari browser.
    setTimeout(() => {
      window.open(url, "_blank");
    }, 100);
  }
};

export const isOnlinePayment = (selectedSubMenu: any): boolean => {
  return !selectedSubMenu.startChat && selectedSubMenu.subMenu.menu_type === "online_payment";
};
